// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1ED__","cell":"ColumnAccessor_cell__2iiQS","firstCellAccent":"ColumnAccessor_firstCellAccent__3AYPl"};